import env from "shared/env"
import ErrorLogger from "@kaspernj/api-maker/build/error-logger"

if (env.RAILS_ENV == "test" && !window.DISABLE_DEBUG_ERRORS_IN_TESTS) {
  window.errorLogger = new ErrorLogger()
  window.errorLogger.enable()
}
